import { useTranslation } from "react-i18next";
import { Combine } from "lucide-react";
import { Button } from "components/common/Button";
import { RoomsControl } from "../RoomsControl";
import type { RoomsListHeaderProps } from "./types";

export const RoomsListHeader = ({
  roomCount,
  canEdit,
  isMergeSelecting,
  onOpenRoomsPanel,
  onStartMerge,
}: RoomsListHeaderProps) => {
  const { t } = useTranslation();

  const hasActions =
    !isMergeSelecting &&
    (onOpenRoomsPanel !== undefined || onStartMerge !== undefined);

  if (!hasActions) return null;

  return (
    <div className="flex items-center gap-3">
      {onOpenRoomsPanel && (
        <RoomsControl
          count={roomCount}
          canEdit={canEdit}
          onOpenPanel={onOpenRoomsPanel}
        />
      )}
      {onStartMerge && (
        <Button
          variant="outline"
          size="sm"
          onClick={onStartMerge}
          startAdornment={<Combine className="w-3.5 h-3.5" />}
          className="shrink-0"
        >
          {t("smartSurveyor.rooms.mergeRooms")}
        </Button>
      )}
    </div>
  );
};
